var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-vertical-center",staticStyle:{"position":"absolute","width":"100%","height":"100%","z-index":"99"}},[_c('div',{staticClass:"margin-center",staticStyle:{"width":"97%","height":"96%"},attrs:{"id":"map"}})])
}]

export { render, staticRenderFns }